import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Header } from "./Header";
import { ContactSection } from "./ContactSection";

export const PublicPage = ({ eyebrow, title, desc, testId, back = "/", backLabel = "Kembali ke beranda", children, hideFooter = false }) => {
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-background" data-testid={testId}>
      <Header profile={profile} />
      <section className="emerald-bg pattern-overlay text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <Link to={back} className="inline-flex items-center gap-2 text-sm text-emerald-200 hover:text-white" data-testid={`${testId}-back`}><ArrowLeft size={16} /> {backLabel}</Link>
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.25em] text-[#80b996]">{eyebrow}</p>
          <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">{title}</h1>
          {desc && <p className="mt-3 text-emerald-100/85 max-w-2xl">{desc}</p>}
        </div>
      </section>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">{typeof children === "function" ? children(profile) : children}</main>
      {!hideFooter && <ContactSection profile={profile} />}
    </div>
  );
};
